import axios from 'axios';

const uploadFileToBucket = (formData, config) => {
  return axios.post('/api/s3/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    ...config,
  });
};

const getUploadedFiles = (config) => {
  return axios.get('/api/s3', config);
};

const downloadFile = (name, config) => {
  return axios.get(`/api/s3/download/${name}`, config);
};

const deleteFile = (name, config) => {
  return axios.delete('/api/s3', { data: { name: name }, ...config });
};

const deleteGeneratedDocumentByName = (name, config) => {
  return axios.delete('/api/s3/generatedDocument', {
    data: { name: name },
    ...config,
  });
};

const getGeneratedDocuments = () => {
  return axios.get('/api/s3/generatedDocuments');
};

const downloadGeneratedDocument = (documentName) => {
  return axios.get(`/api/s3/downloadGeneratedDocument/${documentName}`);
};

export {
  uploadFileToBucket,
  getUploadedFiles,
  downloadFile,
  deleteFile,
  getGeneratedDocuments,
  downloadGeneratedDocument,
  deleteGeneratedDocumentByName,
};
